import { __assign } from "tslib";
// DS: I21A
// from GDrive
import React from 'react';
import IconWrap from '../IconWrap';
var SquareHeartFilled = function (props) {
    return (React.createElement(IconWrap, __assign({}, props),
        React.createElement("svg", { width: "0", height: "0", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M12.04 17.796l7.04-6.593V9.199L16.568 7h-2.294l-1.98 1.742a.384.384 0 0 1-.508 0L9.806 7H7.512L5 9.2v1.972l7.04 6.624z", stroke: "currentColor", fillRule: "evenodd" }))));
};
SquareHeartFilled.displayName = 'SquareHeartFilled';
export default SquareHeartFilled;
//# sourceMappingURL=SquareHeartFilled.js.map